/* global FontLoader */

import { BlockA } from './block-a';
import { HomepageHero } from './homepage-hero';
import { HeroCrossSell } from './hero-x-sell';

export function init() {
	if (typeof FontLoader === 'undefined') {
		_init();
	} else {
		FontLoader.then(() => _init());
	}

	function _init() {
		BlockA();
		HomepageHero();
		HeroCrossSell();
	}
}
